"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  return <ul className="space-y-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm tracking-widest text-muted-foreground hover:text-primary transition-colors duration-300 uppercase">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socials = [{
    icon: Instagram,
    href: "https://www.instagram.com/ceeday.detailing/",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Youtube,
    href: "https://www.youtube.com/channel/UC9mDWzgVkLhlYd8NIEVcmUw",
    label: "Youtube"
  }];
  return <footer id="footer" className="dark bg-background text-foreground pt-20 pb-8 border-t border-border/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630148/img/ceeday_logo_gold_luxury.png" alt="Logo" className="h-7 object-contain" />
            </Link>
            <p className="mt-6 text-sm tracking-wider text-muted-foreground max-w-xs leading-relaxed">Where automotive passion meets uncompromising craftsmanship. Your vehicle restored to its best form.</p>
          </div>

          {}
          <div className="flex flex-col md:items-center">
            <div className="w-full md:w-auto">
              <h3 className="font-default text-sm tracking-widest uppercase mb-6 text-foreground font-semibold">
                Navigation
              </h3>
              <MenuProvider menu_id="91">
                <FooterMenuLinks />
              </MenuProvider>
            </div>
          </div>

          {}
          <div className="flex flex-col md:items-end">
            <div className="w-full md:w-auto">
              <h3 className="font-default text-sm tracking-widest uppercase mb-6 text-foreground font-semibold md:text-right">
                Connect
              </h3>
              <div className="flex space-x-6 md:justify-end">
  {socials.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} newTab className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label={social.label}>
        <Icon className="size-5" />
      </Link>;
              })}
            </div>
              <div className="mt-8 md:text-right space-y-2">
                <p className="text-sm tracking-widest text-muted-foreground">Ceedaydetailing@Gmail.com</p>
                <p className="text-sm tracking-widest text-muted-foreground">415-867-5690</p>
              </div>
            </div>
          </div>
        </div>

        {}
        <Separator className="bg-border/30 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs tracking-widest text-muted-foreground uppercase text-center md:text-left">
            &copy; {currentYear} Ceeday Detailing. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="#" className="text-xs tracking-widest text-muted-foreground hover:text-primary transition-colors uppercase">
              Privacy Policy
            </Link>
            <Link to="#" className="text-xs tracking-widest text-muted-foreground hover:text-primary transition-colors uppercase">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}